// EventDetailPage.jsx

import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';

const eventData = {
  1: {
    image: '/assets/events/slider/Afterwork.jpg',
    title: 'Afterwork',
    sub: 'DONNERSTAG, 04. SEPTEMBER 2025\nAB 16:00 UHR\nCREMON 11, HAMBURG\n\nTREFFT UNTERNEHMER, SELBSTSTÄNDIGE UND INTERESSIERTE ZUM ENTSPANNTEN NETZWERKEN.KNÜPFT NEUE KONTAKTE, TAUSCHT IDEEN AUS UND LASST DEN TAG BEI ESSEN & DRINKS IN LOCKERER ATMOSPHÄRE AUSKLINGEN - MITTEN IN DER HAMBURGER INNENSTADT.',
  },
};

const EventDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const event = eventData[id];

  if (!event) {
    navigate('/events');
    return null;
  }

  return (
    <Box>
      <Navbar />

      {/* Main Content */}
      <Box
        sx={{
          minHeight: 'calc(100vh - 160px)',
          display: 'flex',
          flexDirection: {xs: 'column', md: 'row'},
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding:'0px 40px',
          width: '100%',
          height: '100%'
        }}
      >
        {/* Left Half - Image */}
        <Box
          sx={{
            width: { xs: 'unset', md: '50%' },
            maxWidth: {xs: '400px', md: '1200px'},
          }}
        >
          <Box
            component="img"
            src={event.image}
            alt={event.title}
            sx={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              aspectRatio: '1/1',
            }}
          />
        </Box>

        {/* Right Half - Content */}
        <Box
          sx={{
            width: { xs: 'unset', md: '50%' },
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            pl: { xs: 0, md: 8 },
            mt: {xs: 8, md: 0}
          }}
        >
          {/* Title */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 3,
              whiteSpace: 'pre-line',
              fontSize: { xs: '2rem', md: '3rem' },
            }}
          >
            {event.title}
          </Typography>

          {/* Subtext */}
          <Typography
            variant="h5"
            sx={{
              textAlign: 'left',
              mb: 4,
              color: 'text.secondary',
              fontSize: { xs: '1rem', md: '1.5rem' },
              whiteSpace: 'pre-line',
            }}
          >
            {event.sub}
          </Typography>

          {/* Jetzt Buchen Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box
                component={RouterLink}
                to='/kontakt'
                sx={{
                  cursor: 'pointer',
                  maxWidth: '228.5px',
                  position: 'relative',
                  display: 'inline-block',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.1)',
                  },
                }}
              >
                <Box
                  component="img"
                  src="/assets/misc/Button.png"
                  alt="Jetzt eintragen"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    pointerEvents: 'none',
                  }}
                />
                <Typography
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontFamily: 'Montserrat',
                    fontStyle: 'italic',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    pointerEvents: 'none',
                    fontSize: '1.2rem',
                    whiteSpace: 'nowrap',
                    width: '90%',
                  }}
                >
                  JETZT EINTRAGEN
                </Typography>
              </Box>
            </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

export default EventDetailPage;